import { motion } from "framer-motion";
import { Flag, Shield, BarChart, Heart, RotateCcw, Settings, BookOpen } from "lucide-react";

const items = [
  { key: "get-started", icon: Flag, label: "Get Started" },
  { key: "setting-up-policies", icon: Shield, label: "Setting Up Policies" },
  { key: "managing-dashboard", icon: BarChart, label: "Managing Provider Dashboard" },
  { key: "claims-handling", icon: Heart, label: "Claims Handling" },
  { key: "payment-settlements", icon: RotateCcw, label: "Payment & Settlements" },
  { key: "technical-support", icon: Settings, label: "Technical Support & Troubleshooting" },
  { key: "best-practices", icon: BookOpen, label: "Best Practices & Guidelines" },
];

export default function Categories({ selected = "get-started", onSelect }) {
  return (
    <div className="grid grid-cols-2 gap-4 mt-6 sm:grid-cols-3 lg:grid-cols-7">
      {items.map((it, idx) => (
        <motion.div
          key={it.key}
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: idx * 0.05 }}
          onClick={() => onSelect?.(it.key)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onSelect?.(it.key)}
          className={`flex flex-col gap-2 items-center p-4 rounded-xl border shadow-sm cursor-pointer transition-colors ${
            selected === it.key
              ? 'bg-emerald-50 border-emerald-600/60'
              : 'bg-white border-emerald-600/20 hover:border-emerald-600/40'
          }`}
        >
          <it.icon className="text-emerald-600" size={20} />
          <div className="text-xs text-center text-gray-700">{it.label}</div>
        </motion.div>
      ))}
    </div>
  );
}


